﻿import { createPwaInstallPrompt } from "./pwaInstallPrompt"

window.pwaInstallPrompt = createPwaInstallPrompt()
